import { useEffect, useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IAttemptListItemResponseForWorkOrder } from "@miplatform/types";
import type { CalendarFilters } from "../../CalendarToolBar/useCalendarFilterGroup";

export const useUnassignedWorkOrdersListViewModel = (
  filters: CalendarFilters
) => {
  const stateManager = useComponentState();
  const [workOrders, setWorkOrders] = useState<
    IAttemptListItemResponseForWorkOrder[]
  >([]);

  const loadWorkOrders = () =>
    stateManager.run(async () => {
      const activeFilters: Record<string, unknown> = {};

      if (filters.status?.value) {
        activeFilters.attemptStatus = { eq: filters.status.value };
      }
      if (filters.builder?.value) {
        activeFilters["home/builderId"] = {
          type: "guid",
          value: filters.builder.value,
        };
      }
      if (filters.community?.value) {
        activeFilters["home/communityId"] = {
          type: "guid",
          value: filters.community.value,
        };
      }
      if (filters.dueDate) {
        activeFilters.dueDate = { eq: filters.dueDate.toDate() };
      }

      const response = await taskService.attempts.getAllWorkOrders({
        filters: activeFilters,
        top: 50,
        skip: 0,
        sort: "scheduledStartDate",
      });
      if (response.status === HTTP_STATUSES.OK) {
        const data = response.data ?? [];
        const result = data.filter(
          (workOrder: IAttemptListItemResponseForWorkOrder) =>
            !workOrder?.assignedUserId
        );
        setWorkOrders(result);
      } else {
        setWorkOrders([]);
      }
    });

  useEffect(() => {
    loadWorkOrders();
  }, [
    filters.status?.value,
    filters.builder?.value,
    filters.community?.value,
    filters.dueDate,
  ]);

  return {
    workOrders,
    isLoading: stateManager.isBusy(),
  };
};
